import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERFORMANCESCOREDETAIL,
  DELETE_PERFORMANCESCOREDETAIL,
  UPDATE_PERFORMANCESCOREDETAIL,
  ADD_NEW_PERFORMANCESCOREDETAIL,
} from "./actionType";

import {
  getPerformanceScoreDetailSuccess,
  getPerformanceScoreDetailFail,
  deletePerformanceScoreDetailSuccess,
  deletePerformanceScoreDetailFail,
  updatePerformanceScoreDetailSuccess,
  updatePerformanceScoreDetailFail,
  addPerformanceScoreDetailSuccess,
  addPerformanceScoreDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePerformanceScoreDetailApi,
  getPerformanceScoreDetailApi,
  updatePerformanceScoreDetailApi,
  deletePerformanceScoreDetailApi,
  addNewPerformanceScoreDetailApi
} from "../../helpers/backend_helper";

function* getPerformanceScoreDetail({ payload: performanceScoreDetail }) {
  try {
    const response = yield call(getPerformanceScoreDetailApi, performanceScoreDetail);
    yield put(getPerformanceScoreDetailSuccess(GET_PERFORMANCESCOREDETAIL, response.data));
  } catch (error) {
    yield put(getPerformanceScoreDetailFail(GET_PERFORMANCESCOREDETAIL, error));
  }
}

function* onUpdatePerformanceScoreDetail({ payload: performanceScoreDetail }) {
  try {
    if (performanceScoreDetail.setApprove) {
      const response = yield call(approvePerformanceScoreDetailApi, performanceScoreDetail);
      yield put(updatePerformanceScoreDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePerformanceScoreDetailApi, performanceScoreDetail);
      yield put(updatePerformanceScoreDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePerformanceScoreDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePerformanceScoreDetail({ payload: performanceScoreDetail }) {
  try {
    const response = yield call(deletePerformanceScoreDetailApi, performanceScoreDetail);
    yield put(deletePerformanceScoreDetailSuccess({ performanceScoreDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePerformanceScoreDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPerformanceScoreDetail({ payload: performanceScoreDetail }) {
  try {
    const response = yield call(addNewPerformanceScoreDetailApi, performanceScoreDetail);
    yield put(addPerformanceScoreDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPerformanceScoreDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPerformanceScoreDetail() {
  yield takeEvery(GET_PERFORMANCESCOREDETAIL, getPerformanceScoreDetail);
}

export function* watchUpdatePerformanceScoreDetail() {
  yield takeEvery(UPDATE_PERFORMANCESCOREDETAIL, onUpdatePerformanceScoreDetail);
}

export function* watchDeletePerformanceScoreDetail() {
  yield takeEvery(DELETE_PERFORMANCESCOREDETAIL, onDeletePerformanceScoreDetail);
}

export function* watchAddNewPerformanceScoreDetail() {
  yield takeEvery(ADD_NEW_PERFORMANCESCOREDETAIL, onAddNewPerformanceScoreDetail);
}

function* performanceScoreDetailSaga() {
  yield all([
    fork(watchGetPerformanceScoreDetail),
    fork(watchDeletePerformanceScoreDetail),
    fork(watchUpdatePerformanceScoreDetail),
    fork(watchAddNewPerformanceScoreDetail)
  ]);
}

export default performanceScoreDetailSaga;
